import { useTranslation } from 'react-i18next';

export default function TrustBar() {
  const { t } = useTranslation();

  const logos = [
    { src: '/logos/heineken.png', alt: 'Heineken' },
    { src: '/logos/jgcarrion.png', alt: 'J. García Carrión' },
    { src: '/logos/capwatt.png', alt: 'CapWatt' },
    { src: '/logos/enso-energy.png', alt: 'Enso Energy' },
    { src: '/logos/damel.png', alt: 'Damel' },
    { src: '/logos/idea-ingenieria.png', alt: 'IDEA Ingeniería' },
    { src: '/logos/neumaticos-soledad.png', alt: 'Neumáticos Soledad' },
    { src: '/logos/marin-gimenez.png', alt: 'Marín Giménez' }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {t('trust.titulo')}
          </h3>
          <p className="text-gray-600">
            {t('trust.subtitulo')}
          </p>
        </div>

        <div className="relative overflow-hidden">
          {/* Logos en carrusel infinito */}
          <div className="flex animate-scroll">
            {/* Primera copia de logos */}
            {logos.map((logo, index) => (
              <div
                key={`first-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ minWidth: '180px' }}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-16 max-w-[160px] object-contain grayscale hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
            {/* Segunda copia para loop infinito */}
            {logos.map((logo, index) => (
              <div
                key={`second-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ minWidth: '180px' }}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-16 max-w-[160px] object-contain grayscale hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
